import React, { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";
import api from "../../../../../api";

const StickyNav = () => {
  const [menu, setMenu] = useState([]);

  // Fixed correct order
  const correctOrder = [
    "About",
    "Policy",
    "Collections",
    "E-Resources",
    "Open Access Resources"
  ];

  // API endpoints for each menu
  const pages = {
    "About": "/api/sitepages/about-us/library",
    "Collections": "/api/sitepages/about-us/librarycollections",
    "E-Resources": "/api/sitepages/about-us/libraryeresources",
    "Open Access Resources": "/api/sitepages/about-us/libraryopenaccess",
  };

  // Route mapping
  const linkConfig = {
    "About": "/library",
    "Policy": "/library/policy",
    "Collections": "/library/collections",
    "E-Resources": "/library/eresources",
    "Open Access Resources": "/library/openaccess",
  };

  useEffect(() => {
    const checkPages = async () => {
      const activeMenu = [];

      // Always include Policy (static)
      activeMenu.push("Policy");

      for (const [label, endpoint] of Object.entries(pages)) {
        try {
          const res = await api.get(endpoint);

          if (res.data && Object.keys(res.data).length > 0) {
            activeMenu.push(label);
          }
        } catch (err) {
          console.warn(`${label} page missing → hidden`);
        }
      }

      // ⭐ SORT based on correct order
      const sortedMenu = correctOrder.filter(item => activeMenu.includes(item));

      setMenu(sortedMenu);
    };

    checkPages();
  }, []);

  return (
    <section className="navigation_section sticky-nav">
      <div className="container-fluid px-md-5">
        <div className="row align-items-center justify-content-center">
          <div className="col-md-10 col-11">
            <div className="tab-menu-lib sticky-menu py-1 text-center">
              <ul>
                {menu.map((item, idx) => (
                  <li key={idx}>
                    <NavLink
                      to={linkConfig[item]}
                      end={item === "About"}
                      className={({ isActive }) =>
                        `sticky-nav-link ${isActive ? "active" : ""}`
                      }
                    >
                      {item}
                    </NavLink>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default StickyNav;
